module.exports = __webpack_public_path__ + "static/neutral-marker-base-0cea6727b2c321f276238dfcbf3a595c.png";